import { gql } from '@apollo/client';

export const GET_TASK_FIELDS = gql`
  query GetTaskFields($taskId: String!) {
    vm {
      task(taskId: $taskId) {
        taskId
        title
        taskItems {
          ... on VOLUNTEER_TaskItemFieldType {
            taskItemId
            field {
              __typename
              taskFieldId
              name
            }
          }
        }
      }
    }
  }
`;
